import { gql } from '@apollo/client';

export const SEND_CONTACT_FORM = gql`
  mutation contactForm($contactForm: ContactFormInput!) {
    contactForm(contactForm: $contactForm) {
      success
      message
    }
  }
`;
